import { render, staticRenderFns } from "./ChangePhoneModal.vue?vue&type=template&id=5c3c0308&scoped=true&"
import script from "./ChangePhoneModal.vue?vue&type=script&lang=js&"
export * from "./ChangePhoneModal.vue?vue&type=script&lang=js&"
import style0 from "./ChangePhoneModal.vue?vue&type=style&index=0&id=5c3c0308&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3c0308",
  null
  
)

export default component.exports